<template>
  <!-- 监控回放 -->

  <div>
    <el-row>
      <el-col :span="6">
        <basic-container>
          <div :style="'height:' + (bodyHeight - 150) + 'px'">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="视频列表" name="first">
              <el-tree
                default-expand-all
                ref="treeRef"
                node-key="id"
                :data="cameraList"
                :props="treeAreaProps"
                :expand-on-click-node="false"
                :highlight-current="true"
                @node-click="treeNodeClick"
              >
                <span slot-scope="{ node }" class="custom-tree-node">
                  <template>
                    <div style="display: flex; justify-content: space-between">
                      <div style="width: 200px; overflow-x: hidden; text-overflow: ellipsis">
                        {{
                          node.data.monitorName != '' && node.data.monitorName != undefined
                            ? node.data.monitorName
                            : node.data.areaName
                        }}
                      </div>
                      <div @click.stop="collect(node.data)">
                        <i
                          class="el-icon-star-off"
                          style="margin-left: 30px"
                          v-if="node.data.monitorName != '' && node.data.monitorName != undefined"
                          :class="{
                            activeCollect: node.data.favoriteFlag == 1,
                          }"
                        >
                        </i>
                      </div>
                    </div>
                  </template>
                </span>
              </el-tree>
            </el-tab-pane>
            <el-tab-pane label="收藏列表" name="second">
              <el-tree
                default-expand-all
                ref="treeRef2"
                node-key="id"
                :data="favoriteList"
                :props="treeAreaProps"
                :expand-on-click-node="false"
                :highlight-current="true"
                @node-click="favoritetreeNodeClick"
              >
                <span slot-scope="{ node }" class="custom-tree-node">
                  <template>
                    <div style="display: flex; justify-content: space-between">
                      <div style="width: 200px; overflow-x: hidden; text-overflow: ellipsis">
                        {{
                          node.data.monitorName != '' && node.data.monitorName != undefined
                            ? node.data.monitorName
                            : node.data.areaName
                        }}
                      </div>
                      <div @click.stop="collect(node.data)">
                        <i
                          class="el-icon-star-off"
                          style="margin-left: 30px"
                          v-if="node.data.monitorName != '' && node.data.monitorName != undefined"
                          :class="{
                            activeCollect: node.data.favoriteFlag == 1,
                          }"
                        >
                        </i>
                      </div>
                    </div>
                  </template>
                </span>
              </el-tree>
            </el-tab-pane>
          </el-tabs>
          </div>
        </basic-container>
      </el-col>
      <el-col :span="18">
        <basic-container>
        <div class="right" :style="`height: ${bodyHeight - 150}px;flex:1;overflow: scroll;`">
          <GBRecordDetail ref="reviewRef" v-if="showReview"></GBRecordDetail>
        </div>
      </basic-container>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import crypto from 'crypto';
import axios from './api/index';
import { getCameraList } from '@/api/nursingHome/security.js';
import player from '@/views/nursingHome/components/jessibuca.vue';
import GBRecordDetail from './GBRecordDetail.vue';
import {
  videoareatree,
  monitorvideoareapage,
  monitorvideofavorite,
  favoritelist,
} from '@/api/call-system/video';
export default {
  components: { player, GBRecordDetail },
  data() {
    return {
      activeName: 'first',
      treeAreaProps: {
        label: 'monitorName',
        value: 'id',
        children: 'videoList',
      },
      favoriteList: [],

      favoritePage: {
        current: 1,
        size: 9,
        total: 0,
      },
      page: {
        current: 1,
        size: 9,
        total: 0,
      },
      showReview: false,
      currentAraeId: '',
      favoritecurrentAraeId: '',
      loading: false,
      cameraUrlList: [],
      favoritecameraUrlList: [],
      currentCameraUrlList: [],
      cameraList: [],

      loading: false,

      isLoging: false,
    };
  },
  async created() {
    let that = this;
    let loginParam = {
      username: 'admin',
      password: '0904281cb421f092c5e7f6bb91f2956f',
    };

    this.isLoging = true;
    let timeoutTask = setTimeout(() => {
      that.$message.error('监控回访登录超时');
      that.isLoging = false;
    }, 1000);
    await axios({
      method: 'get',
      url: '/debug/api/user/login',
      params: loginParam,
    })
      .then(function (res) {
        window.clearTimeout(timeoutTask);
        console.log('-----');
        if (res.data.code === 0) {
          that.isLoging = false;
          //登录成功后
          that.showReview = true;
        } else {
          that.isLoging = false;
          that.showReview = false;
          that.$message({
            showClose: true,
            message: '登录失败，无法使用监控回访',
            type: 'error',
          });
        }
      })
      .catch(function (error) {
        window.clearTimeout(timeoutTask);
        that.$message.error(error.response.data.msg);
      });
    this.initData(); // 刷新下拉列表数据
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        instantData_chart_line: {},
      };
    },
  },
  mounted() {
    console.log('-------', this.bodyHeight);
  },
  activated() {},

  methods: {
    handleClick(data) {
      if (this.activeName != 'first') {
        favoritelist().then((res) => {
          this.favoriteList = res.data;
        });
      } else {
        this.initData();
      }
    },
    collect(data) {
      monitorvideofavorite({
        favoriteFlag: data.favoriteFlag == 0 ? 1 : 0,
        id: data.id,
      }).then((res) => {
        data.favoriteFlag =
          data.favoriteFlag == 0 ? (data.favoriteFlag = 1) : (data.favoriteFlag = 0);
      });
    },
    searchClear() {
      this.searchForm.name = '';
    },

    initData() {
      this.cameraUrlList = [];
      videoareatree().then((res) => {
        this.cameraList = res.data;
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.treeRef.setCurrentKey(this.cameraList[0].id);
            this.treeNodeClick(this.cameraList[0]);
          });
        });
      });
    },

    treeNodeClick(data, node) {
      if (data.monitorName != '' && data.monitorName != undefined) {
        this.$refs.reviewRef.setData(data.deviceNo, data.passageNo);
        console.log(data);
      } else {
      }
    },
    favoritetreeNodeClick(data, node) {
      if (data.monitorName != '' && data.monitorName != undefined) {
        this.$refs.reviewRef.setData(data.deviceNo, data.passageNo);
      } else {
      }
      console.log(data);
      // this.cameraUrlList = [];
      // this.currentCameraUrlList = [];
      // this.cameraUrlList.push(data.url);
      //   this.handleCurrentChange(1);
    },
  },
};
</script>

<style scoped>

.right {
  display: flex;
}
.activeCollect {
  color: rgb(255, 0, 0);
}
.cardStyle {
  border: 1px solid #000;
  padding: 10px 25px;
}
.dataClass {
  font-size: 15px;
}
.cardBody {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-column-gap: 20px;
}
.liveBody {
  display: grid;

  grid-template-columns: repeat(3, 400px);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  grid-template-rows: repeat(3, 350px);
}
.live {
  border: 1px solid #000; /* 设置网格线条颜色 */
  height: 350px;
  width: 400px;
  background: #000;
  display: flex;
  align-items: center;
}
</style>
